import 'rc-slider/assets/index.css'
import './index.css'
import Slider from 'rc-slider'
export default Slider
